import type { Ref } from "react";
import { forwardRef } from "react";

import type { Props as BaseImageProps } from "~/components/common/base-image";
import type { ImageStyle } from "~/components/content/content-schema-render/image/enums";
import { GalleryItem } from "~/components/image-gallery/gallery-item";

import type { StyledProps } from "./styles";
import {
  ArticleImageContainer,
  DescriptionContainer,
  DescriptionOuterContainer,
  DescriptionTitle,
  ImageContainer,
  StyledImage,
} from "./styles";

export type Props = {
  className?: string;
  imageProps: BaseImageProps;
  imageStyle?: ImageStyle;
  title: string;
} & Partial<PropsFromStyledProps<StyledProps>>;

export const ArticleImage = forwardRef<HTMLDivElement, Props>(
  (
    {
      className,
      imageProps,
      imageStyle,
      responsiveDescriptionVariants = { desktopUp: "show", mobileUp: "show", tabletUp: "show" },
      responsiveImageVariants = { desktopUp: "normal", mobileUp: "normal", tabletUp: "normal" },
      title = "",
    },
    reference,
  ) => (
    <GalleryItem src={imageProps.src} title={title}>
      {({ open, ref }) => (
        <ArticleImageContainer
          $responsiveDescriptionVariants={responsiveDescriptionVariants}
          $responsiveImageVariants={responsiveImageVariants}
          ref={reference}
        >
          <ImageContainer onClick={open}>
            <StyledImage ref={ref as Ref<HTMLImageElement>} {...imageProps} className={className} />
          </ImageContainer>

          <DescriptionOuterContainer $imageStyle={imageStyle}>
            <DescriptionContainer>
              <DescriptionTitle>{title}</DescriptionTitle>
            </DescriptionContainer>
          </DescriptionOuterContainer>
        </ArticleImageContainer>
      )}
    </GalleryItem>
  ),
);

ArticleImage.displayName = "ArticleImage";
